import {
    BackButton,
    classNames,
    CodeForm,
    layout,
    theme,
    useIdle,
    View,
    ViewContent,
    ViewHeader,
    ViewHeaderItem
} from "@variocube/cube-ui";
import * as React from "react";
import {useEffect} from "react";
import {stylesheet} from "typestyle";
import {useLocalization} from "../i18n";

export interface PinPadViewProps {
    onCode: (code: string) => Promise<void>;
    onCancel: () => void;
}

export function PinPadView({onCode, onCancel}: PinPadViewProps) {
    const {t} = useLocalization();
    const idle = useIdle(15);
    useEffect(() => {
        if (idle) {
            onCancel()
        }
    }, [idle, onCancel]);
    return (
        <View>
            <ViewHeader className={theme.lessContrast}>
                <ViewHeaderItem>
                    <BackButton onClick={onCancel} label={t("Back")}/>
                </ViewHeaderItem>
                <ViewHeaderItem fill className={classNames(layout.paddingMedium, styles.branding)}>
                    {t("appName")}
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent className={classNames(layout.vertical, layout.center)}>
                <CodeForm strings={t} onVerify={onCode}/>
            </ViewContent>
        </View>
    )
}

const styles = stylesheet({
    branding: {
        fontSize: "2em",
        fontWeight: 300,
        color: "var(--color-primary)"
    },
});
